import { Button, Flex } from '@chakra-ui/react'
import { useContext } from 'react'
import Link from 'next/link'

import globalContext from '../../context/GlobalContext'

const AppNavigation = () => {
  const { analytics: { logEvent } } = useContext(globalContext)

  const logNavigation = (id: string) => {
    logEvent('select_content', {
      content_type: 'page_section',
      content_id: id
    })
  }

  return (
    <Flex as='nav' wrap='wrap' minHeight={70} px={4} justify='center' align='center'>
      <Link href='/' passHref><Button variant='link' as='a' p={2} m={2}>Home</Button></Link>
      <Link href='/#intro' passHref><Button variant='link' as='a' p={2} m={2} onClick={() => logNavigation('intro')}>Intro</Button></Link>
      <Link href='/#artwork' passHref><Button variant='link' as='a' p={2} m={2} onClick={() => logNavigation('artwork')}>Artwork</Button></Link>
      <Link href='/#roadmap' passHref><Button variant='link' as='a' p={2} m={2} onClick={() => logNavigation('roadmap')}>Roadmap</Button></Link>
      <Link href='/#team' passHref><Button variant='link' as='a' p={2} m={2} onClick={() => logNavigation('team')}>Team</Button></Link>

      <Link href='/popfungi' passHref><Button variant='link' as='a' p={2} m={2}>PopFungi</Button></Link>
      <Link href='/forage' passHref><Button variant='link' as='a' p={2} m={2}>Forage!</Button></Link>
    </Flex>
  )
}

export default AppNavigation
